import React from "react";
import {Box, Button, Modal, Text} from "@nike/eds";
import {edsSpace16} from "@nike/eds/dist/tokens";
import RocketIcon from "../shared/rocket";

interface ManualClearingSuccessModalProps {
    isOpen: boolean;
    onDismiss: () => void;
}

function ManualClearingSuccessModal({isOpen, onDismiss}: ManualClearingSuccessModalProps) {
    return (
        <Modal
            isOpen={isOpen}
            onDismiss={onDismiss}
            headerSlot="Manual clearing event(s) triggered"
            footerSlot={<Button variant="primary" onClick={onDismiss}>Close</Button>}
        >
            <Box>
                <Text>
                    Please note: processing the event(s) will take some time
                </Text>
                <div style={{marginTop: edsSpace16, textAlign: "center"}}>
                    <RocketIcon/>
                </div>

            </Box>
        </Modal>
    );
}

export default ManualClearingSuccessModal;
